//@getters

import { GetterTree } from 'vuex'
import { authState } from './state'

export const getters: GetterTree<any, authState> = {
  currentCourse: (state: any) => state.currentCourse,
  preRegisterUsername: (state: any) => state.preRegisterUsername,
  preRegisterCode: (state: any) => state.preRegisterCode,
  hasNationalCode: (state: any) => state.hasNationalCode,
  nationalCodePreview: (state: any) => state.nationalCodePreview,
  parvandehInfo: (state: any) => state.parvandehInfo,
  extraFields: (state: any) => state.extraFields,
}
